import { formatMoney } from '@shopify/theme-currency';
export var featuredIngredients = function () {
    var ingredientToggles = document.querySelectorAll('[data-ingredient-modal-toggle]');
    if (ingredientToggles) {
        ingredientToggles.forEach(function (toggle) {
            toggle.addEventListener('click', function () {
                var ingredientModal = document.querySelector('[data-ingredient-modal]');
                var articleTitle = toggle.getAttribute('data-article-title');
                var articleContent = toggle.getAttribute('data-article-content');
                var blogURL = toggle.getAttribute('data-blog-url');
                var buildModal = function () {
                    var modal = "\n          <div data-ingredient-modal class=\"ingredient-modal\">\n            <div class=\"modal__inner\">\n              <button data-close-modal data-target=\"data-ingredient-modal\" class=\"modal__close\"></button>\n              <div data-ingredient-title class=\"modal__title\"></div>\n              <div data-ingredient-content class=\"modal__content\"></div>\n              <a data-blog-url class=\"modal__link btn btn--text\">Find out more about our ingredients</a>\n            </div>\n            <div data-close-modal data-target=\"data-ingredient-modal\" class=\"modal__overlay\"></div>\n          </div>";
                    document.body.insertAdjacentHTML('beforeend', modal);
                    ingredientModal = document.querySelector('[data-ingredient-modal]');
                    var modalCloseButtons = document.querySelectorAll('[data-close-modal]');
                    modalCloseButtons.forEach(function (button) {
                        button.addEventListener('click', function () {
                            closeModal(button);
                        });
                    });
                };
                var populateModal = function () {
                    var modalTitle = ingredientModal.querySelector('[data-ingredient-title]');
                    var modalContent = ingredientModal.querySelector('[data-ingredient-content]');
                    var modalURL = ingredientModal.querySelector('[data-blog-url]');
                    modalTitle.innerHTML = articleTitle;
                    modalContent.innerHTML = articleContent;
                    modalURL.setAttribute('href', blogURL);
                };
                var openModal = function () {
                    ingredientModal.classList.add('ingredient-modal--show');
                };
                var closeModal = function (button) {
                    var targetModal = button.getAttribute('data-target');
                    var modal = document.querySelector('[' + targetModal + ']');
                    modal.classList.remove('ingredient-modal--show');
                };
                if (ingredientModal) {
                    populateModal();
                    openModal();
                }
                else {
                    buildModal();
                    populateModal();
                    openModal();
                }
            });
        });
    }
};
export var stickyAddToCart = function () {
    var staticATCButton = document.querySelector('[data-static-add-to-cart]');
    var stickyATCButton = document.querySelector('[data-sticky-add-to-cart]');
    if (staticATCButton && stickyATCButton) {
        var events = ['load', 'scroll'];
        events.forEach(function (event) {
            window.addEventListener(event, function () {
                var staticATCButtonBox = staticATCButton.getBoundingClientRect();
                if (staticATCButtonBox.top < 0) {
                    document.body.classList.add('has-scrolled--show-sticky-atc');
                }
                else {
                    document.body.classList.remove('has-scrolled--show-sticky-atc');
                }
            });
        });
    }
};
export var unitPriceTags = function () {
    document.addEventListener('change', function (event) {
        var variantTitle = event.dataset.variant.title;
        var unitPriceTagsContainer = document.querySelector('[data-unit-price-tags]');
        var tags = unitPriceTagsContainer.querySelectorAll('.unit-price');
        tags.forEach(function (tag) {
            if (tag.getAttribute('data-variant') == variantTitle) {
                tag.style.display = 'block';
            }
            else {
                tag.style.display = 'none';
            }
        });
        unitPriceTagsContainer.setAttribute('data-current-variant', variantTitle);
    });
};
export var productSubscription = function () {
    var subscriptionSelectors = document.querySelector('[data-subscription-selectors]');
    if (subscriptionSelectors) {
        var subscriptionGroups = subscriptionSelectors.querySelectorAll('.product__subs__group');
        subscriptionGroups.forEach(function (group) {
            var label = group.querySelector('label');
            label.addEventListener('click', function () {
                var currentSelection = subscriptionSelectors.querySelector('.product__subs__group--selected');
                currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.classList.remove('product__subs__group--selected');
                label.parentElement.classList.add('product__subs__group--selected');
            });
        });
    }
    var subscriptionModal = document.querySelector('[data-subscription-modal]');
    if (subscriptionModal) {
        var openModal_1 = function () {
            subscriptionModal.classList.add('subscription-modal--show');
        };
        var closeModal_1 = function (button) {
            var targetModal = button.getAttribute('data-target');
            var modal = document.querySelector('[' + targetModal + ']');
            modal.classList.remove('subscription-modal--show');
        };
        var subscriptionModalToggle = document.querySelector('[data-subscription-modal-toggle]');
        var modalCloseButtons = subscriptionModal.querySelectorAll('[data-close-modal]');
        subscriptionModalToggle.addEventListener('click', function () {
            openModal_1();
        });
        modalCloseButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                closeModal_1(button);
            });
        });
    }
};
export var buyNowPayLater = function () {
    var bnplContainer = document.querySelector('[data-bnpl-container]');
    var bnplInstalments = bnplContainer === null || bnplContainer === void 0 ? void 0 : bnplContainer.getAttribute('data-bnpl-instalments');
    var bnplPayment = bnplContainer === null || bnplContainer === void 0 ? void 0 : bnplContainer.querySelector('[data-bnpl-payment]');
    if (bnplContainer && bnplPayment && bnplInstalments > 0) {
        document.addEventListener('change', function (event) {
            var variantPrice = event.dataset.variant.price;
            var bnplInstalment = variantPrice / bnplInstalments;
            bnplInstalment = formatMoney(bnplInstalment, window.theme.moneyFormat);
            bnplPayment.innerHTML = bnplInstalment;
        });
    }
};
